/** @format */
'use client';
import useLocales from '@common/application/hooks/useLocales/useLocales';
import { Locale } from '@common/types/locale';
import DevExpress from 'devextreme';
import { SelectBox } from 'devextreme-react/select-box';
import DataSource from 'devextreme/data/data_source';
import { useParams, usePathname, useRouter } from 'next/navigation';
import React, { useMemo, useState } from 'react';
import { FlagIcon, FlagIconCode } from 'react-flag-kit';
import { useIntl } from 'react-intl';
import styles from './UserMenu.module.css';
import ValueChangedEvent = DevExpress.ui.dxSelectBox.ValueChangedEvent;

const ItemTemplate = (item: Locale) => {
  return (
    <div className={styles.localeItem}>
      {item.nativeDescription} - ({item.bcp47})
    </div>
  );
};

const GroupRender = (group: { key: string; items: Array<Locale> }) => {
  return (
    <div className={styles.localeGroup}>
      <FlagIcon code={group.key as FlagIconCode} size={16} />
      {group.key ?? 'Unknown'}
    </div>
  );
};

function LocaleSelect() {
  const { localesData, countryAlphaCodes } = useLocales();
  const intl = useIntl();
  const params = useParams<{ locale: string }>();
  // const { locale, setLocale } = useConfigStore((state) => state);
  const [locale, setLocale] = useState(params?.locale);
  const router = useRouter();
  const pathname = usePathname();

  const onLocaleChanged = async (e: ValueChangedEvent) => {
    console.log(e);
    if (e.previousValue === e.value || !pathname) return;
    // setLocale(e.value);
    const splitPath = pathname.split('/');
    if (e.value === splitPath[1]) return;
    setLocale(e.value);
    splitPath[1] = e.value;
    router.push(splitPath.join('/'));
  };

  const data = useMemo(
    () =>
      new DataSource({
        store: {
          data: localesData ?? [],
          type: 'array',
          key: 'bcp47',
        },
        group: 'countryId',
      }),
    [localesData],
  );

  return (
    <SelectBox
      groupRender={GroupRender}
      dataSource={data ?? []}
      grouped={true}
      itemRender={ItemTemplate}
      onValueChanged={onLocaleChanged}
      value={locale}
      valueExpr={'bcp47'}
      displayExpr={'nativeDescription'}
      label={intl.formatMessage({ defaultMessage: 'Select Language' })}
    ></SelectBox>
  );
}

export default LocaleSelect;
